<template>
  <dropdown class="login-personalize-list-item-action"
            :data-border="false"
            dataMenuWidth="115px"
            data-icon="mdi-dots-vertical">

    <p class="login-personalize-list-item-action-item pointer"
       @click.stop="goToEditPage">
      {{$t('message.generics.message.edit')}}
    </p>

    <p class="login-personalize-list-item-action-item pointer"
       @click.stop="showDeleteModal">
      {{$t('message.generics.message.delete')}}
    </p>

    <confirmation-modal :value="showingStyleDeleteModal"
                        :confirm-label="$t('message.generics.message.confirm')"
                        @confirm="deleteStyle"
                        @cancel="closeDeleteModal">
      <span slot="heading">
        {{ $t('message.loginPersonalize.message.deleteStyle') }}
      </span>
      <span>
        {{ $t('message.loginPersonalize.message.deleteStyleConfirm') }}
      </span>
    </confirmation-modal>
  </dropdown>
</template>
  
<script>
import Dropdown from "@components/Dropdown";
import ConfirmationModal from "@components/ConfirmationModal";

export default {
  components: {
    Dropdown,
    ConfirmationModal,
  },

  data() {
    return {
      showingStyleDeleteModal: false,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {},
  methods: {
    goToEditPage() {
      this.$router.push(`/personalizar-login/${this.item.id}`);
    },
    async deleteStyle() {
      await this.$api.core.account.captiveStyle.delete({
        styleId: this.item.id,
      });

      this.closeDeleteModal();

      this.$emit("deleted");
    },
    closeDeleteModal() {
      this.showingStyleDeleteModal = false;
    },
    showDeleteModal() {
      this.showingStyleDeleteModal = true;
    },
  },
};
</script>
  
<style lang="scss" scoped>
.login-personalize-list-item-action {
  .login-personalize-list-item-action-item {
    margin-bottom: 0px;
    font-size: 12px;
    color: #707070;
    font-weight: 600;
    margin-bottom: 5px;

    &:hover {
      transform: translateY(-1px);
    }

    &:active {
      box-shadow: none;
      transform: translateY(1px);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
  